import Types from './types';

export default class Dispatcher {
    constructor(dispatch) {
        this.dispatch = dispatch;
    }

    // Stats
    fetchStatsStart = () => this.dispatch({ type: Types.FETCH_STATS_START, payload: {} });

    // Users
    fetchUsersStart = (params) => this.dispatch({ type: Types.FETCH_USERS_START, payload: params });

    fetchUserByIdStart = (id) => this.dispatch({ type: Types.FETCH_USER_BY_ID_START, payload: id });

    updateUserStart = (id, data) => this.dispatch({ type: Types.UPDATE_USER_START, payload: { id, data } });

    deleteUserStart = (id) => this.dispatch({ type: Types.DELETE_USER_START, payload: id });
    toggleUserStatusStart = (id) => this.dispatch({ type: Types.TOGGLE_USER_STATUS_START, payload: id });
    resetUserPasswordStart = (id, newPassword) => this.dispatch({ type: Types.RESET_USER_PASSWORD_START, payload: { id, newPassword } });

    // Therapists
    fetchPendingTherapistsStart = () => this.dispatch({ type: Types.FETCH_PENDING_THERAPISTS_START, payload: {} });

    approveTherapistStart = (id, data) => this.dispatch({ 
        type: Types.APPROVE_THERAPIST_START, 
        payload: { id, data } 
    });

    rejectTherapistStart = (id, reason) => this.dispatch({ 
        type: Types.REJECT_THERAPIST_START, 
        payload: { id, reason } 
    });

    fetchTherapistsStart = (params) => this.dispatch({ type: Types.FETCH_THERAPISTS_START, payload: params });

    // Reviews
    fetchReviewsStart = (params) => this.dispatch({ type: Types.FETCH_REVIEWS_START, payload: params });

    moderateReviewStart = (id, data) => this.dispatch({ 
        type: Types.MODERATE_REVIEW_START, 
        payload: { id, data } 
    });

    resetError = () => this.dispatch({ type: Types.RESET_ERROR, payload: {} });

    // Businesses
    fetchBusinessesStart = (params) => this.dispatch({ type: Types.FETCH_BUSINESSES_START, payload: params });
    fetchBusinessByIdStart = (id) => this.dispatch({ type: Types.FETCH_BUSINESS_BY_ID_START, payload: id });
    updateBusinessStart = (id, data) => this.dispatch({ type: Types.UPDATE_BUSINESS_START, payload: { id, data } });
    updateBusinessStatusStart = (id, status) => this.dispatch({ type: Types.UPDATE_BUSINESS_STATUS_START, payload: { id, status } });
    createBusinessStart = (data) => this.dispatch({ type: Types.CREATE_BUSINESS_START, payload: data });
    deleteBusinessStart = (id) => this.dispatch({ type: Types.DELETE_BUSINESS_START, payload: id });
    bulkDeleteBusinessesStart = (ids) => this.dispatch({ type: Types.BULK_DELETE_BUSINESSES_START, payload: ids });
    bulkUpdateBusinessStatusStart = (ids, status) => this.dispatch({ type: Types.BULK_UPDATE_BUSINESS_STATUS_START, payload: { ids, status } });

    // User bulk
    bulkDeleteUsersStart = (ids) => this.dispatch({ type: Types.BULK_DELETE_USERS_START, payload: ids });
    bulkToggleUsersStart = (ids, action) => this.dispatch({ type: Types.BULK_TOGGLE_USERS_START, payload: { ids, action } });
    hardDeleteUserStart = (id) => this.dispatch({ type: Types.HARD_DELETE_USER_START, payload: id });
    bulkHardDeleteUsersStart = (ids) => this.dispatch({ type: Types.BULK_HARD_DELETE_USERS_START, payload: ids });

    // Create user
    createUserStart = (data) => this.dispatch({ type: Types.CREATE_USER_START, payload: data });

    // Restore user
    restoreUserStart = (id) => this.dispatch({ type: Types.RESTORE_USER_START, payload: id });
}
